<template>
  <div :class="{online:isOnline}" class="artwork-item item grid-cell">
    <router-link :to="uri" class="artwork-card">
      <div class="item-image-wrap">
        <div :style="{backgroundImage:`url(${thumbnailUrl})`}" class="item-image" v-if="thumbnailUrl"></div>
        <div class="item-image no-image" v-else></div>
      </div>
      <div class="item-description">
        <span :title="artwork.title" class="item-title">{{ artwork.title }}</span>
        <span class="item-credits" v-if="artists">{{ artists }}</span>
      </div>
    </router-link>
    <div class="tools">
      <div class="play-badge" v-if="isOnline">
        <span>Playing</span>
      </div>
      <div :class="{spin:isOnline}" @click="requirePlay" class="button play">
        <i :class="isOnline ? 'control' : 'play'"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { Artwork } from '../../models/ArtworkData'

export default {
  props: {
    /** @type Artwork */
    artwork: Artwork,
    uri: String,
    isOnline: Boolean
  },
  computed: {
    thumbnailUrl () {
      return this.artwork ? this.artwork.thumbnailUrl() : ''
    },
    artists () {
      return this.artwork.artists.map(artist => artist.fullName).join(', ')
    }
  },
  methods: {
    requirePlay () {
      this.$emit('requirePlay', this.artwork)
    }
  }
}
</script>

<style lang="scss">
  @import "../../scss/vars";

  .artwork-item {
    $padding: $basic-size / 2;
    padding: $padding;

    .artwork-card {
      position: relative;
      display: flex;
      flex-flow: column;
      width: 100%;
      height: 100%;

      .item-image-wrap {
        /*flex-shrink: 1;*/
        height: auto;
        flex-basis: 100%;

        .item-image {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
      }

      .item-description {
        background: #fff;
        padding: $basic-padding/4 $basic-padding/2 $basic-padding/2;

        span {
          display: block;
          flex-shrink: 0;
        }

        .item-credits {
          font-size: $font-size-caption;
          /*margin-bottom: 1rem;*/
        }
      }
    }

    &.online {
      .artwork-card {
        //box-shadow: 0 0 0 $basic-size/8 $px-color-green;
      }

      .item-description {
        background: $px-color-green;
      }
    }

    .tools {
      position: absolute;
      display: flex;
      align-items: center;

      top: $padding;
      right: $padding;
      min-height: $basic-size;
      min-width: $basic-size;

      .button {
        box-shadow: none;
        background: $bg-semi-transparent-color;

        i.control {
          &:before, &:after {
            content: none;
          }

          background: url("/img/px-control-2a.png") no-repeat center center;
          background-size: 24px;

        }
      }

      .play-badge {
        align-self: stretch;
        display: flex;
        align-items: center;
        padding: $basic-padding;
        background: $px-color-green;
        font-size: $font-size-caption;
        font-weight: 400;
      }
    }
  }

  @keyframes spin {
    from {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
</style>
